import AbstractApiRequest from "~/core-ui/ts/request/AbstractApiRequest";
import {AbstractEntityBuilder} from "~/ts/library/AbstractEntity";
import OpenApiResult from "~/ts/library/openApi/OpenApiResult";

export default class AbstractOpenApiRequest<DataType extends object> extends AbstractApiRequest<OpenApiResult<DataType>, DataType> {
    protected createApiResultByResponse(response: any, dataType: AbstractEntityBuilder<any> | undefined): any {
        return new OpenApiResult(response, dataType);
    }
}